import { objectToSelectOptions } from './helpers'

export const deliveryStates = {
    null: 'Por entregar',
    entregado: 'Entregado',
    pendiente: 'Pendiente',
    rechazado: 'Rechazado',
    cancelado: 'Cancelado'
}

export const deliveryStatesOptions = objectToSelectOptions(deliveryStates)


export default {
    deliveryStates,
    deliveryStatesOptions
}
